module.exports = __webpack_public_path__ + "img/registration.82ee8e1c.png";